import { AfterContentInit, Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-stack-icon',
  templateUrl: './icon-stack-icon.component.html',
  styleUrls: ['./icon-stack-icon.component.scss']
})
export class IconStackIconComponent implements OnInit, AfterContentInit {
  private _symbol: string = '';
  private _ready = false;
  private _symbolReady = false;

  @HostBinding('style.--symbol-family') fontFamily: string = ''
  @HostBinding('style.--icon-size') iconSize = '';
  @HostBinding('style.--icon-char') content: string = '';
  @HostBinding('style.--icon-offset-x') offsetX: string;
  @HostBinding('style.--icon-offset-y') offsetY: string;
  @HostBinding('style.--icon-angle') theta: string;
  constructor(private domNode: ElementRef<HTMLDivElement>) { }
  @Input() set symbol(sym: string) {
    const custom = sym.split(':');
    if (custom[0] !== 'custom') return;
    if (custom.length < 2) return;
    const [fontName, fontChar, fontSize, xOffset, yOffset, theta] = custom[1].split(',');
    this._symbol = sym;
    this.fontFamily = fontName;
    this.content = `'\\${fontChar}'`;
    this.iconSize = fontSize + 'pt';
    this.offsetX = xOffset;
    this.offsetY = yOffset;
    this.theta = theta;


    this._symbolReady = true;
  }
  ngOnInit(): void {
    this._ready = true;

  }
  ngAfterContentInit(): void {
    this.InitSymbol();
  }
  InitSymbol() {
    if (this._symbol === '') {
      let symbol = getComputedStyle(this.domNode.nativeElement).getPropertyValue('--symbol');
      if (symbol === '') {
        setTimeout(() => {
          this.InitSymbol();
        })
        return;
      }
      symbol = symbol.trim();
      symbol = symbol.substring(1,symbol.length-1);
      this.symbol = symbol;

    }
  }

}
